import { isNumber } from "lodash";

export const getMinMaxDiameter = (productos) => {
    let min = Number.MAX_VALUE;
    let max = Number.MIN_VALUE;
    for (let i = 0; i < productos.length; i++) {
        const producto = productos[i];
        // if (producto.Diametro === '') {
        //     min = 0
        //     max = 100
        //     continue
        // }
        if (isNumber(parseFloat(producto.Diametro)) === false) continue
        if (parseFloat(producto.Diametro) < min) {
            min = parseFloat(producto.Diametro)
        }
        if (parseFloat(producto.Diametro) > max) {
            max = parseFloat(producto.Diametro)
        }
    }
    if (productos.length <= 0) {
        return { min: 0, max: 0 }
    }
    return { min: min, max: max }
}